import { TypeChatbotUIWithoutUnresolvableLinksResponse } from 'contentful-types'
import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import ChatbotUI from './ChatbotUI'
import { BlockRenderer } from '@/siteBuilder/renderer/contentful/BlockRenderer'
import { extractExampleQuestions } from './welcomeMessageUtils'

/**
 * ContentfulChatbotUI - Connects Contentful data to ChatbotUI component
 *
 * Supports:
 * - Dynamic welcome message from Contentful (Card component)
 * - Dynamic secondary welcome message from Contentful (Card component)
 * - Dynamic example questions from Contentful
 * - Dynamic message and button labels (user tag, assistant tag, clear chat)
 * - All fields are optional - if not provided, they won't be displayed
 */
const ContentfulChatbotUI = withContentful<TypeChatbotUIWithoutUnresolvableLinksResponse['fields']>(ChatbotUI, {
  welcomeMessage: (entry) => entry.fields.welcomeMessage && <BlockRenderer block={entry.fields.welcomeMessage} />,
  secondaryWelcomeMessage: (entry) =>
    entry.fields.secondaryWelcomeMessage && <BlockRenderer block={entry.fields.secondaryWelcomeMessage} />,
  exampleQuestions: (entry) => extractExampleQuestions(entry.fields.exampleQuestions?.map((item) => item.fields.text)),
  placeholder: (entry) => entry.fields.placeholder,
  placeholderDesktop: (entry) => entry.fields.placeholderDesktop,
  welcomeTagLabel: (entry) => entry.fields.welcomeTagLabel,
  userTagLabel: (entry) => entry.fields.userTagLabel,
  clearChatButtonLabel: (entry) => entry.fields.clearChatButtonLabel,
  assistantTagLabel: (entry) => entry.fields.assistantTagLabel,
  feedbackText: (entry) => entry.fields.feedbackText,
  addCommentCtaText: (entry) => entry.fields.addCommentCtaText,
  feedbackConfirmationText: (entry) => entry.fields.feedbackConfirmationText,
  feedbackPlaceholderText: (entry) => entry.fields.feedbackPlaceholderText,
  disclaimerTitle: (entry) => entry.fields.disclaimerTitle && <BlockRenderer block={entry.fields.disclaimerTitle} />,
  disclaimerBody: (entry) => entry.fields.disclaimerBody && <BlockRenderer block={entry.fields.disclaimerBody} />,
})

export default ContentfulChatbotUI
